import { Component, Inject, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BetStatusList } from "src/_constants/bet_filters";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { Location } from "@angular/common";
import * as moment from "moment";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material";

@Component({
  selector: "app-bets-settlements",
  templateUrl: "./bets-settlements.component.html",
  styleUrls: ["./bets-settlements.component.scss"],
})
export class BetsSettlementsComponent implements OnInit {
  providerId = "";
  sportId = "";
  sportName = "";
  eventId = "";
  openDate = 0;
  marketId = "";
  marketName = "";
  marketType = "";
  eventName = "";
  status = "";
  bets = 0;
  selected: any = {
    startDate: moment(),
    endDate: moment(),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  displayedColumns = ["TotalBets", "Action"]
  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private appService: AppService,
    public dialog: MatDialog,
    private location: Location,
  ) {}

  ngOnInit() {
    this.activeRouter.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
      this.eventId = params["eventId"];
      this.openDate = parseInt(params["openDate"]);
      this.marketId = params["marketId"];
      this.marketName = params["marketName"];
      this.marketType = params["marketType"];
      this.eventName = params["eventName"];
      this.status = params["status"];
    });
    //this.getMarketBets();
  }

  onDateChangeHandler = () => {
    this.getMarketBets();
  };

  getMarketBets() {
    let filters = {
      startTime: this.selected.startDate !== null ? Math.floor(new Date(this.selected.startDate).getTime() / 1000) : 0,
      endTime: this.selected.endDate !== null ? Math.floor(new Date(this.selected.endDate).getTime() / 1000) : 0,
      providerId: this.providerId,
      sportId: this.sportId,
      eventId: this.eventId,
      marketId: this.marketId,
      status: this.status,
      betCount: true,
    }
    try {
      this.appService
        .getMarketsBets(filters)
        .subscribe((response) => {
            this.bets = response.totalCount
        });
    } catch (err) {
      console.log(err);
    }
  }

  goBack = () => {
    this.location.back();
  };

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  voidBets() {
    try {
      let dialogRef = this.dialog.open(VoidBetsModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          startTime: this.selected.startDate !== null ? Math.floor(new Date(this.selected.startDate).getTime() / 1000) : 0,
          endTime: this.selected.endDate !== null ? Math.floor(new Date(this.selected.endDate).getTime() / 1000) : 0,
          providerId: this.providerId,
          sportId: this.sportId,
          eventId: this.eventId,
          marketId: this.marketId,
          marketName: this.marketName,
          marketType: this.marketType,
          status: this.status,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getMarketBets();
        }
      });
    } catch (err) {}
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./void-bets-dialog.component.html",
  styleUrls: ["./bets-settlements.component.scss"],
})
export class VoidBetsModalComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public Data,
    public dialogRef: MatDialogRef<VoidBetsModalComponent>,
    private appService: AppService,
    private authenticationService: AuthenticationService,
  ) {}

  data = this.Data
  reason = "";
  password  = "";
  ngOnInit () {
    console.log(this.data)
  }

  isValid() {
    if (this.password === "" || this.reason === "") {
      return true;
    }
    return false;
  }

  reset(){
    this.password = "";
    this.reason = "";
  }

  onSubmit() {
    if (this.data.alertStatus) {
      let filters = {
        transactionId: this.data.transactionId,
        alertStatus: "Void",
        rollbackReason: this.reason,
        password: this.password,
      }
      this.appService.settleAlertedBet(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close(true);
          this.authenticationService.openSnackBar("Bet Voided");
        } else {
          this.authenticationService.openErrorSnackBar(res.errorDescription);
        }
      });
  } else if(this.data.title === "market") {
    let filters = {
      betIds: this.data.betIds,
      providerId: this.data.providerId,
      sportId: this.data.sportId,
      eventId: this.data.eventId,
      marketId: this.data.marketId,
      marketName: this.data.marketName,
      marketType: this.data.marketType,
      rollbackType: "VOID",
      rollbackReason: this.reason,
      password: this.password,
      status: this.data.status,
    }
    try {
      this.appService
        .voidBets(filters).subscribe((res) => {
          if (res.status === "RS_OK"){
              this.dialogRef.close(true);
              this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
        });
    } catch (err) {
      console.log(err);
    }

  } else if(this.data.level === "operator") {
    let filters = {
      betId: this.data.transactionId,
      rollbackReason: this.reason,
      password: this.password,
      status : this.data.status,
    }
    try {
      this.appService
        .opBetVoid(filters).subscribe((res) => {
          if (res.status === "RS_OK"){
              this.dialogRef.close(true);
              this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
        });
    } catch (err) {
      console.log(err);
    }

  } else {
    let filters = {
      startTime: this.data.startTime,
      endTime: this.data.endTime,
      providerId: this.data.providerId,
      sportId: this.data.sportId,
      eventId: this.data.eventId,
      marketId: this.data.marketId,
      marketName: this.data.marketName,
      marketType: this.data.marketType,
      rollbackType: "VOID",
      rollbackReason: this.reason,
      password: this.password,
      status: this.data.status,
    }
    try {
    this.appService
      .timelyVoidBets(filters).subscribe((res) => {
        if (res.status === "RS_OK"){
            this.dialogRef.close(true);
            this.authenticationService.openSnackBar(res.errorDescription);
        } else {
          this.authenticationService.openErrorSnackBar(res.errorDescription);
        }
      });
  } catch (err) {
    console.log(err);
  }
}
}
 
}
